import React from "react";

// Design-spec toggle: 40x22 track (radius 11), 16px white knob inset 3px.
// Off = rgba(20,33,61,.15); on = brass by default, or `onColor` (e.g. green
// #3a7d4f for the Account-related email toggle). `disabled` blocks clicks.
const ToggleButton = ({
  toggleOption,
  callbackFunc,
  onColor = "#8a6231",
  disabled = false,
}) => {

  const toggleHandler = () => {
    if (disabled) return;
    callbackFunc();
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!toggleOption}
      aria-disabled={disabled}
      onClick={toggleHandler}
      className={"relative flex-none transition-colors duration-200 " + (disabled ? "cursor-not-allowed" : "cursor-pointer")}
      style={{
        width: "40px",
        height: "22px",
        borderRadius: "11px",
        background: toggleOption ? onColor : "rgba(20,33,61,.15)",
      }}
    >
      <span
        className="absolute bg-white rounded-full transition-all duration-200"
        style={{
          width: "16px",
          height: "16px",
          top: "3px",
          left: toggleOption ? "21px" : "3px",
          boxShadow: "0 1px 2px rgba(20,33,61,.2)",
        }}
      ></span>
    </button>
  );
};

export default ToggleButton;
